// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"72f3a431","304":"a1c18854","383":"38b9e275","472":"28cde2d0","547":"c884327b","651":"f791a220","752":"2a4847b2","923":"a1c18854"}[chunkId] + ".css";
};